import axios from 'axios';
import { get } from "lodash";
import { getCookie, deleteCookie } from "../helpers/storage";

var regsiterApi = axios.create({
    baseURL: process.env.REACT_APP_YII_API_URL
});

regsiterApi.interceptors.request.use((config) => {
    let conf = {
        ...config,
        headers: {
            ...config.headers,
            'Authorization': 'Bearer ' + (getCookie() || false)
        }
    }
    return conf;
})

regsiterApi.interceptors.response.use(response => {
    let data = get(response, "data");
    if (get(data, "status") === 401) {
        deleteCookie();
        window.location.href = `${process.env.REACT_APP_URL_PREFIX}/`;
    }
    return {
        ...response,
        data
    }
}, (error) => {
    const { status } = get(error, "response", {});

    if (status === 401) {
        deleteCookie();
        window.location.href = `${process.env.REACT_APP_URL_PREFIX}/`;
    }
    return Promise.reject(error)
})

export default regsiterApi;